interface ButtonForumItem {
    title: string;
    url: string;
}

const buttonsForumObj: ButtonForumItem[] = [
    {
        title: 'Stats Generiche',
        url: 'https://gwf.forumcommunity.net/?t=45002345'
    },
    {
        title: 'Hall of Champions',
        url: 'https://gwf.forumcommunity.net/?t=11122017'
    },
    {
        title: 'Hall of Fame',
        url: 'https://gwf.forumcommunity.net/?f=8057712'
    },
    {
        title: 'Roster Attivo',
        url: 'https://gwf.forumcommunity.net/?f=8346557'
    },
];

export default buttonsForumObj;
